// @flow
import React from "react";
import type {StoreState} from "../../../reducers/combinedReducers";
import _ from "lodash";
import {Dispatch} from "redux";
import {togglePhotoAction} from "../../../actions/ebadge/photo/creators/photoEBadgeActionCreator";
import {connect} from "react-redux";
import FaSquare from 'react-icons/lib/fa/square-o';
import FaCheckSquare from 'react-icons/lib/fa/check-square-o';


function PhotoCheckbox(props: { registrationCode: string, enabled: boolean, checked: boolean, toggle: (registrationCode: string) => any }) {
    return (
        <div className={props.enabled ? `clickable` : ""} onClick={() => {
            if (props.enabled) {
                props.toggle(props.registrationCode)
            }
        }}>
            {
                props.checked &&
                <FaCheckSquare/>
            }
            {
                !props.checked &&
                <FaSquare/>
            }
        </div>
    )
}

function mapStateToProps(state: StoreState, ownProps: { registrationCode: string }) {

    const checked = _.includes(state.photoEBadgeAction.del.bulk.registrationCodes, ownProps.registrationCode);

    return {
        checked
    }
}

function mapDispatchToProps(dispatch: Dispatch) {

    return {
        toggle: (registrationCode: string) => {
            dispatch(togglePhotoAction(registrationCode));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotoCheckbox);


// WEBPACK FOOTER //
// ./src/components/ebadge/photo/PhotoCheckbox.js